import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitAutocompleteHeader } from '../../TransitAutocompleteHeader';
import { TransitInputHeader } from '../../TransitInputHeader';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseConsigneeProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  editDisabled: boolean;
}

export const HouseConsignee: React.FC<HouseConsigneeProps> = ({ form, houseForm, editDisabled }) => {
  const consigneeParent = form?.values?.Consignment?.Consignee;
  const isConsigneeDefined = !!consigneeParent && (!!consigneeParent.name || !!consigneeParent?.identificationNumber);

  return (
    <Stack mb="md">
      <Title order={5} fw={600}>
        Consignee
      </Title>
      <Grid>
        <Grid.Col span={6}>
          <TransitInputHeader
            form={houseForm}
            name="Consignee.identificationNumber"
            label="Identification Number"
            parents={isConsigneeDefined ? [consigneeParent.identificationNumber] : []}
            disabled={editDisabled || isConsigneeDefined}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <TransitInputHeader
            form={houseForm}
            name="Consignee.name"
            label="Name"
            parents={isConsigneeDefined ? [consigneeParent.name] : []}
            disabled={editDisabled || isConsigneeDefined}
          />
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignee.Address.streetAndNumber"
            label="Street and Number"
            parents={isConsigneeDefined ? [consigneeParent.Address?.streetAndNumber] : []}
            disabled={editDisabled || isConsigneeDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignee.Address.postcode"
            label="Postcode"
            parents={isConsigneeDefined ? [consigneeParent.Address?.postcode] : []}
            disabled={editDisabled || isConsigneeDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitInputHeader
            form={houseForm}
            name="Consignee.Address.city"
            label="City"
            parents={isConsigneeDefined ? [consigneeParent.Address?.city] : []}
            disabled={editDisabled || isConsigneeDefined}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TransitAutocompleteHeader
            form={houseForm}
            parents={isConsigneeDefined ? [consigneeParent.Address?.country] : []}
            name="Consignee.Address.country"
            disabled={editDisabled || !!isConsigneeDefined}
            placeholder="Country"
            code="CL008"
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
